import type { ThemeConfig } from "antd";
import { colors, fonts } from "./tokens";

// Tema do antd alinhado ao manual de padrões, para que os componentes do antd
// (Select, DatePicker, Modal, Drawer, Table, message...) sigam o novo layout
// sem sobrescritas globais de CSS.
export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: colors.primary,
    colorLink: colors.primary,
    colorLinkHover: colors.primaryHover,
    colorSuccess: colors.success,
    colorWarning: colors.warning,
    colorError: colors.danger,
    colorInfo: colors.primary,
    colorText: colors.text,
    colorTextSecondary: colors.textSecondary,
    colorTextPlaceholder: colors.textMuted,
    colorTextDisabled: colors.textMuted,
    colorBorder: colors.borderStrong,
    colorBorderSecondary: colors.border,
    colorBgLayout: colors.bg,
    colorBgContainerDisabled: colors.surfaceSubtle,
    colorFillAlter: colors.surfaceSubtle,
    colorSplit: colors.track,
    fontFamily: fonts.body,
    fontSize: 14,
    borderRadius: 12,
    borderRadiusLG: 18,
    borderRadiusSM: 8,
    controlHeight: 44,
    controlHeightLG: 50,
    controlHeightSM: 32,
    controlOutline: colors.primarySoft,
    controlOutlineWidth: 4,
    boxShadowSecondary: "0 18px 48px rgba(11, 31, 58, 0.18)",
    colorBgMask: "rgba(11, 31, 58, 0.45)",
  },
  components: {
    Button: {
      fontWeight: 700,
      primaryShadow: "none",
      defaultShadow: "none",
      dangerShadow: "none",
      paddingInline: 18,
    },
    Input: { paddingInline: 14 },
    Select: { optionSelectedBg: colors.primarySoft },
    Modal: { titleFontSize: 22, borderRadiusLG: 18 },
    Table: {
      headerBg: colors.surfaceSubtle,
      headerColor: colors.textSecondary,
      headerSplitColor: "transparent",
      rowHoverBg: colors.surfaceSubtle,
      borderColor: colors.track,
    },
    Tooltip: { colorBgSpotlight: colors.navy },
    Segmented: {
      trackBg: colors.bg,
      itemSelectedColor: colors.primary,
      trackPadding: 3,
    },
    Drawer: { paddingLG: 24 },
  },
};
